<ng-template [ngIf]="associativaForm && !tariffaSel">
	<h4 *ngIf="title">{{title}}</h4>
	<form [formGroup]="associativaForm" (ngSubmit)="update();">

		<div class="row"
			*ngIf="inserimento && legale && legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cognome/Nome'"
				[valueInput]="legale.nominativo"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo persona'"
				[valueInput]="legale.tipoPersona?.label"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice fiscale'"
				[valueInput]="legale.codiceFiscale"></div>
		</div>
		<div class="row"
			*ngIf="inserimento && legale && legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Ragione sociale'"
				[valueInput]="legale.ragioneSociale"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo persona'"
				[valueInput]="legale.tipoPersona?.label"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Partita iva'"
				[valueInput]="legale.partitaIva"></div>
		</div>
		<div class="row">
			<div comboModInput class="col-sm-6" [mandatory]="true"
				[control]="associativaForm.controls['categoriaLegaleIncaricato']" [labelInput]="'Tipo legale'"
				formControlName="categoriaLegaleIncaricato"
				[objectReference]="formLegaleIncaricato.categoriaLegaleIncaricato"
				(onReturn)="formLegaleIncaricato.categoriaLegaleIncaricato = $event; formLegaleIncaricato.compensoPattuito = null"
				[optionsCombo]="categorie" [ngModel]="formLegaleIncaricato.categoriaLegaleIncaricato"></div>

			<div datePickerInput class="col-sm-6" [control]="associativaForm.controls['dataInizioIncarico']"
				[mandatory]="false" [labelInput]="'Data conferimento incarico'" formControlName="dataInizioIncarico"
				[(ngModel)]="formLegaleIncaricato.dataInizioIncarico"></div>

			<!--<div textInputCurrency class="col-sm-3" [location]="'default'" [labelInput]="'Compenso pattuito'"
				[control]="associativaForm.controls['compensoPattuito']" formControlName="compensoPattuito"
				[(ngModel)]="formLegaleIncaricato.compensoPattuito"
				[submitPending]="formLegaleIncaricato.categoriaLegaleIncaricato?.label !== 'LEGALE ESTERNO'"></div>-->

			<!--<div datePickerInput class="col-sm-4" [mandatory]="true"
				[control]="associativaForm.controls['dataAssociazione']" [labelInput]="'Data associazione fascicolo'"
				formControlName="dataAssociazione" [(ngModel)]="formLegaleIncaricato.dataAssociazione"></div>-->
		</div>
		<div class="row">

			<div checkBoxRadio class="col-sm-3" [labelInput]="'Principale'"
				[idInput]="inserimento ? 'principale-ins-' + type : 'principale-mod-' + type"
				formControlName="principale" [submitPending]="!canCheckPrimary()"
				[objectReference]="formLegaleIncaricato.principale"
				(onReturn)="formLegaleIncaricato.principale = $event"></div>

			<div checkBoxRadio class="col-sm-3" [labelInput]="'Revoca/rinuncia incarico'" formControlName="revocato"
				[idInput]="inserimento ? 'revocato-ins-' + type : 'revocato-mod-' + type"
				(change)="formLegaleIncaricato.dataRevoca=undefined;" [objectReference]="formLegaleIncaricato.revocato"
				(onReturn)="formLegaleIncaricato.revocato = $event"></div>

			<div datePickerInput class="col-sm-6" [dataDal]="formLegaleIncaricato.dataInizioIncarico"
				[labelInput]="'Data revoca/rinuncia incarico'" formControlName="dataRevoca"
				[submitPending]="!formLegaleIncaricato.revocato" [(ngModel)]="formLegaleIncaricato.dataRevoca"></div>

		</div>
		<div class="row">
			<div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
				[(ngModel)]="formLegaleIncaricato.note"></div>
		</div>

		<br />
		<!--<table class="table table-striped"
			*ngIf="formLegaleIncaricato.categoriaLegaleIncaricato && formLegaleIncaricato.categoriaLegaleIncaricato.descrizione === 'LEGALE ESTERNO'">
			<thead>
				<tr>
					<th scope="col" style="width: 10%;">Seleziona</th>
					<th scope="col" style="width: 20%;">Prestazione</th>
					<th scope="col" style="width: 20%;">Grado Giudizio</th>
					<th scope="col" style="width: 20%;">Importo</th>
					<th scope="col" style="width: 20%;">Importo revisionato</th>
					<th scope="col" style="width: 10%;">Revisiona tariffa</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let item of tariffe; let i = index">
					<td><input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}">
					<td>{{item.tariffa.attivita?.descrizione}}</td>
					<td>{{item.tariffa.grado?.descrizione}}</td>
					<td>{{item.tariffa.tariffaOriginale?.totaleSpese | euro}} &euro;
					</td>
					<td style="text-align: right;"><span *ngIf="item.tariffa.revisionata">{{item.tariffa.totaleSpese |
							euro}}
							&euro;</span></td>
					<td>
						<a class="dropdown-toggle" style="cursor: pointer; color: #0867b4;"
							data-title="Revisiona tariffa" (click)="tariffaSel = item.tariffa; isModifica = true;">
							<span class="glyphicon glyphicon-edit"></span>
						</a>
					</td>
			</tbody>
		</table>-->


		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>
		<div class="row">
			<p class="col-sm-3 col-xs-6">
				<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
			</p>
			<p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Salva'"
				[disabled]="!associativaForm.valid">
		</div>

	</form>
</ng-template>



<ng-template [ngIf]="tariffaSel && !riepilogo">
	<div class="col-sm-12 coldx" >
		<h4>Revisiona tariffa</h4>
	</div>
	<div class="row">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo prestazione'"
			[valueInput]="tariffaSel.attivita ? tariffaSel.attivita.descrizione : ''"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Grado'"
			[valueInput]="tariffaSel.grado ? tariffaSel.grado.descrizione : ''"></div>
		<p class="col-sm-2 col-sm-offset-2">
			<button type="button" class="btn btn-block" (click)="ripristinaTariffaOriginale()">Ripristina
				originale</button>
		</p>
	</div>
	<div class="container_conteggi">
		<h5>
			<strong>Importi tariffa</strong>
		</h5>
		<div textInputCurrency [labelInput]="'Importo'" [(ngModel)]="tariffaSel.imponibile">
		</div>
		<div textInputCurrency [labelInput]="'Spese generali % art.2'" [isNaturalNumber]="true" [(ngModel)]="tariffaSel.speseGenerali">
		</div>
		<div textInputCurrency [labelInput]="'Spese a pié di lista'" [(ngModel)]="tariffaSel.spesePiePagina">
		</div>
		<div textInputCurrency [labelInput]="'Spese esenti IVA ex art. 15 DPR 633/72'"
			[(ngModel)]="tariffaSel.speseEsenti">
		</div>
		<div textInputCurrency [labelInput]="'Maggiorazione p.d. '" [(ngModel)]="tariffaSel.maggiorazione" [maxValue]="100" [isNaturalNumber]="true">
		</div>
	</div>
	<div class="container_conteggi">
		<h5>
			<strong>Accessori</strong>
		</h5>

		<div class="row">
			<div class="parcella_accessori col-sm-offset-2">
				<div singleCheckBoxModInput class="col-xs-6 col-sm-2" [labelInput]="''" idInput="flagIva"
					(onReturn)="flagIVA = $event; changeFlag()" [labelChecked]="'IVA'" [labelNotChecked]="'IVA'"
					[objectReference]="flagIVA"></div>

				<div comboModInput class="col-xs-6 col-sm-3" [labelInput]="''" [labelOption]="'valore'"
					[submitPending]="!flagIVA" [optionsCombo]="ivaOptions" (onReturn)="tariffaSel.iva = $event"
					[objectReference]="tariffaSel.iva"></div>

				<div class="col-xs-6 col-sm-2" singleCheckBoxModInput [labelInput]="''"
					(onReturn)="flagCPA = $event; changeFlag()" [labelChecked]="'CPA'" [labelNotChecked]="'CPA'"
					[showLabel]="true" [objectReference]="flagCPA"></div>

				<div comboModInput class="col-xs-6 col-sm-3" [labelInput]="''" [labelOption]="'valore'"
					[optionsCombo]="cpaOptions" [submitPending]="!flagCPA" (onReturn)="tariffaSel.cpa = $event"
					[objectReference]="tariffaSel.cpa"></div>
			</div>
		</div>
	</div>

	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="tariffaSel = null">Indietro</button>
		</p>
		<p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="riepilogo = true;"
			[labelButton]="'Calcola tariffa'" [disabled]="!tariffaSel.grado && !tariffaSel.attivita"></p>
	</div>
</ng-template>


<ng-template [ngIf]="tariffaSel && riepilogo">

	<div class="titleblock">
		<h3 class="title1level" style="margin-bottom: 20px">Riepilogo</h3>
	</div>
	<div class="row">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo prestazione'"
			[valueInput]="tariffaSel.attivita ? tariffaSel.attivita.descrizione : ''"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Grado'"
			[valueInput]="tariffaSel.grado ? tariffaSel.grado.descrizione : ''"></div>
	</div>
	<div class="container_conteggi">
		<h5>
			<strong>Prospetto finale</strong>
		</h5>

		<div labelTextInput [labelInput]="'Importo'" [typeLabel]="'conteggioProspetto'"
		[valueInput]="tariffaSel.imponibile"></div>
	<div>
	<div labelTextInput [labelInput]="'Maggiorazione p.d. ' + (tariffaSel.maggiorazione ? tariffaSel.maggiorazione : 0) + '%'" [typeLabel]="'conteggioProspetto'"
		[valueInput]="maggiorazioneCalc">
	</div>
	<div labelTextInput [labelInput]="'Totale compensi'"
		[typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleCompensi">
	</div>
		<div labelTextInput
			[labelInput]="('Spese generali art.2 ' + (tariffaSel.speseGenerali ? (tariffaSel.speseGenerali + '% sul compenso totale') : '0% sul compenso totale'))"
			[typeLabel]="'conteggioProspetto'" [valueInput]="speseGenerali">
		</div>
	</div>
	<div>
		<div labelTextInput [labelInput]="'Spese a pié di lista'" [typeLabel]="'conteggioProspetto'"
			[valueInput]="tariffaSel.spesePiePagina">
		</div>
		<div labelTextInput
			[labelInput]="('Cassa avvocati ' + (tariffaSel.cpa ? (tariffaSel.cpa.valore  + '%') : '0%'))"
			[typeLabel]="'conteggioProspetto'" [valueInput]="cpaCalc">
		</div>
		<div labelTextInput [labelInput]="'Totale imponibile'"
			[typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleImponibile">
		</div>
		<div labelTextInput
			[labelInput]="('Iva ' + (tariffaSel.iva ? (tariffaSel.iva.valore + '%'  + ' su imponibile') : '0% su imponibile' ))"
			[typeLabel]="'conteggioProspetto'"
			[valueInput]="totaleImponibile * (tariffaSel.iva ? tariffaSel.iva.valore : 0) / 100">
		</div>
		<div labelTextInput [labelInput]="'Spese esenti IVA ex art. 15 DPR 633/72'"
			[typeLabel]="'conteggioProspetto'" [valueInput]="tariffaSel.speseEsenti">
		</div>
		<div labelTextInput [labelInput]="'Totale tariffa'"
			[typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleTariffa"></div>
	</div>
	</div>


	<div class="row">
		<p class="col-sm-3 col-xs-3">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="riepilogo = false;">Indietro</button>
		</p>
		<p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="salvaTariffa()"
			[labelButton]="'Salva'"></p>
	</div>
</ng-template>









<!-- <h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="associativaForm">
<form [formGroup]="associativaForm" (ngSubmit)="update();">
	<div class="row" *ngIf="inserimento && legale && legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cognome/Nome'"
			[valueInput]="legale.nominativo"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="legale.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Codice fiscale'" [valueInput]="legale.codiceFiscale"></div>
	</div>
	<div class="row" *ngIf="inserimento && legale && legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Ragione sociale'"
			[valueInput]="legale.ragioneSociale"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="legale.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Partita iva'" [valueInput]="legale.partitaIva"></div>
	</div>
	<div class="row">
		<div comboModInput class="col-sm-3" [mandatory]="true"
			[control]="associativaForm.controls['categoriaLegaleIncaricato']"
			[labelInput]="'Tipo legale'"
			formControlName="categoriaLegaleIncaricato"
			[objectReference]="formLegaleIncaricato.categoriaLegaleIncaricato"
			(onReturn)="formLegaleIncaricato.categoriaLegaleIncaricato = $event; formLegaleIncaricato.compensoPattuito = null"
			[optionsCombo] ="categorie"
			[ngModel]="formLegaleIncaricato.categoriaLegaleIncaricato"></div>

		<div datePickerInput class="col-sm-3"
			[control]="associativaForm.controls['dataInizioIncarico']"
			[mandatory]="true" [labelInput]="'Data conferimento incarico'"
			formControlName="dataInizioIncarico"
			[(ngModel)]="formLegaleIncaricato.dataInizioIncarico"></div>

		<div textInputCurrency class="col-sm-3"
      [location]="'default'"
			[labelInput]="'Compenso pattuito'"
      [control]="associativaForm.controls['compensoPattuito']"
			formControlName="compensoPattuito"
			[(ngModel)]="formLegaleIncaricato.compensoPattuito"
      [submitPending]="formLegaleIncaricato.categoriaLegaleIncaricato?.label !== 'LEGALE ESTERNO'"></div>

		<div datePickerInput class="col-sm-3" [mandatory]="true"
			[control]="associativaForm.controls['dataAssociazione']"
			[labelInput]="'Data associazione fascicolo'" formControlName="dataAssociazione"
			[(ngModel)]="formLegaleIncaricato.dataAssociazione"></div>
	</div>
	<div class="row">

		<div checkBoxRadio class="col-sm-3" [labelInput]="'Principale'"
      [idInput]="inserimento ? 'principale-ins-' + type : 'principale-mod-' + type"
			formControlName="principale" [submitPending]="!canCheckPrimary()"
			[objectReference]="formLegaleIncaricato.principale"
			(onReturn)="formLegaleIncaricato.principale = $event"></div>

		<div checkBoxRadio class="col-sm-3"
			[labelInput]="'Revoca/rinuncia incarico'" formControlName="revocato"
      [idInput]="inserimento ? 'revocato-ins-' + type : 'revocato-mod-' + type"
			(change)="formLegaleIncaricato.dataRevoca=undefined;"
			[objectReference]="formLegaleIncaricato.revocato"
			(onReturn)="formLegaleIncaricato.revocato = $event"></div>

		<div datePickerInput class="col-sm-3" [dataDal]="formLegaleIncaricato.dataInizioIncarico"
			[labelInput]="'Data revoca/rinuncia incarico'" formControlName="dataRevoca"
			[submitPending]="!formLegaleIncaricato.revocato"
			[(ngModel)]="formLegaleIncaricato.dataRevoca"></div>

	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="formLegaleIncaricato.note"></div>
	</div>

	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-3">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'"  [disabled]="!associativaForm.valid">
	</div>

</form>
</ng-template>













<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="associativaForm">
<form [formGroup]="associativaForm" (ngSubmit)="update();">
	<div class="row" *ngIf="inserimento && legale && legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cognome/Nome'"
			[valueInput]="legale.nominativo"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="legale.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Codice fiscale'" [valueInput]="legale.codiceFiscale"></div>
	</div>
	<div class="row" *ngIf="inserimento && legale && legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Ragione sociale'"
			[valueInput]="legale.ragioneSociale"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="legale.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Partita iva'" [valueInput]="legale.partitaIva"></div>
	</div>
	<div class="row">
		<div comboModInput class="col-sm-3" [mandatory]="true"
			[control]="associativaForm.controls['categoriaLegaleIncaricato']"
			[labelInput]="'Tipo legale'"
			formControlName="categoriaLegaleIncaricato"
			[objectReference]="formLegaleIncaricato.categoriaLegaleIncaricato"
			(onReturn)="formLegaleIncaricato.categoriaLegaleIncaricato = $event"
			[optionsCombo] ="categorie"
			[ngModel]="formLegaleIncaricato.categoriaLegaleIncaricato"></div>

		<div datePickerInput class="col-sm-3"
			[control]="associativaForm.controls['dataInizioIncarico']"
			[mandatory]="true" [labelInput]="'Data conferimento incarico'"
			formControlName="dataInizioIncarico"
			[(ngModel)]="formLegaleIncaricato.dataInizioIncarico"></div>

		<div datePickerInput class="col-sm-3"
			[dataDal]="formLegaleIncaricato.dataInizioIncarico"
			[labelInput]="'Validit&agrave; incarico'"
			formControlName="dataCessazioneIncarico"
			[(ngModel)]="formLegaleIncaricato.dataCessazioneIncarico"></div>

		<div datePickerInput class="col-sm-3" [mandatory]="true"
			[control]="associativaForm.controls['dataAssociazione']"
			[labelInput]="'Data associazione'" formControlName="dataAssociazione"
			[(ngModel)]="formLegaleIncaricato.dataAssociazione"></div>
	</div>
	<div class="row">

		<div checkBoxRadio class="col-sm-4" [labelInput]="'Principale'"
      [idInput]="inserimento ? 'principale-ins' : 'principale-mod'"
			formControlName="principale" [submitPending]="!canCheckPrimary()"
			[objectReference]="formLegaleIncaricato.principale"
			(onReturn)="formLegaleIncaricato.principale = $event"></div>

		<div checkBoxRadio class="col-sm-4"
			[labelInput]="'Revoca/rinuncia incarico'" formControlName="revocato"
      [idInput]="inserimento ? 'revocato-ins' : 'revocato-mod'"
			(change)="formLegaleIncaricato.dataRevoca=undefined;"
			[objectReference]="formLegaleIncaricato.revocato"
			(onReturn)="formLegaleIncaricato.revocato = $event"></div>

		<div datePickerInput class="col-sm-3" [dataDal]="formLegaleIncaricato.dataInizioIncarico"
			[labelInput]="'Data revoca/rinuncia incarico'" formControlName="dataRevoca"
			[submitPending]="!formLegaleIncaricato.revocato"
			[(ngModel)]="formLegaleIncaricato.dataRevoca"></div>

	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="formLegaleIncaricato.note"></div>
	</div>

	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-3">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'"  [disabled]="!associativaForm.valid">
	</div>

</form>
</ng-template> -->